import { useState } from 'react';

import Configure from 'assets/unifiedCommunication/Configure.svg';
import MyCheckbox from 'common-ui/myCheckbox';
import Switch from 'common-ui/switch';
import { Table } from 'common-ui/table';
import Tag from 'pages/components/tag';

import ChannelConfigurator from '../components/ChannelConfigurator';
import { RowIcon } from '../components/rowIcon';
import { ConfigureButton, ConfigureIcon, StatusText, StatusWrapper } from './ByRole.styles';

const ByRole = () => {
  const data = [
    { id: 1, role: 'Super Admin', viewAccess: false, viewReply: false, status: 'Active' },
    { id: 2, role: 'General Manager', viewAccess: false, viewReply: true, status: 'Active' },
    { id: 3, role: 'Customer Support', viewAccess: false, viewReply: true, status: 'Active' },
    { id: 4, role: 'B2B', viewAccess: false, viewReply: true, status: 'Disabled' },
    { id: 5, role: 'B2B', viewAccess: false, viewReply: true, status: 'Disabled' },
    { id: 6, role: 'B2B', viewAccess: false, viewReply: true, status: 'Disabled' },
  ];

  const [tableData, setTableData] = useState(data);

  const [isChannelModalOpen, setIsChannelModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [channelPermissions, setChannelPermissions] = useState({});

  const handleToggleStatus = (id) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, status: item.status === 'Active' ? 'Disabled' : 'Active' }
          : item
      )
    );
  };

  const handleCheckboxChange = (rowId, field, selectedOption) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === rowId
          ? { ...item, [field]: selectedOption === 'all' ? false : !item[field] }
          : item
      )
    );
  };

  const colors = [
    { bg: 'linear-gradient(135deg, #D0FAE5 0%, #A4F4CF 100%)', color: '#15C7A7' },
    { bg: 'linear-gradient(135deg, #F1F5F9 0%, #E2E8F0 100%)', color: '#62748E' },
    { bg: 'linear-gradient(135deg, #FEF3C6 0%, #FEE685 100%)', color: 'white' },
    { bg: 'linear-gradient(135deg, #2A76E9 0%, #20457B 100%)', color: 'white' },
  ];

  const columns = [
    {
      key: 'role',
      title: 'Role Name',
      dataIndex: 'role',
      render: (value, row, index) => {
        const isSpecialRole = value === 'Super Admin' || value === 'General Manager';
        return (
          <RowIcon
            color={isSpecialRole ? colors[2] : index % 2 === 0 ? colors[0] : colors[1]}
          />
        );
      },
    },
    {
      key: 'viewAccess',
      title: 'View Access',
      dataIndex: 'viewAccess',
      render: (value, row) => (
        <MyCheckbox
          id={`viewAccess-${row.id}`}
          selected={value}
          onClick={(option) => handleCheckboxChange(row.id, 'viewAccess', option)}
        />
      ),
    },
    {
      key: 'viewReply',
      title: 'View and Reply',
      dataIndex: 'viewReply',
      render: (value, row) => (
        <MyCheckbox
          id={`viewReply-${row.id}`}
          selected={value}
          onClick={(option) => handleCheckboxChange(row.id, 'viewReply', option)}
        />
      ),
    },
    {
      key: 'channels',
      title: 'Channels',
      dataIndex: 'channels',
      render: (_, row) => (
        <ConfigureButton
          onClick={() => {
            setSelectedItem(row);
            setIsChannelModalOpen(true);
          }}
        >
          <ConfigureIcon src={Configure} alt="configure" />
          Configure
        </ConfigureButton>
      ),
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (value, row) => {
        const isSpecialRole = row.role === 'Super Admin' || row.role === 'General Manager';
        if (isSpecialRole) return <Tag type="statuses" variant={value} />;

        const isActive = value === 'Active';
        const textColor = isActive ? '#15C7A7' : '#62748E';

        return (
          <StatusWrapper $isActive={isActive}>
            <StatusText $isActive={isActive}>{value}</StatusText>
            <Switch
              activeColor="#15C7A7"
              isOn={isActive}
              onToggle={() => handleToggleStatus(row.id)}
            />
          </StatusWrapper>
        );
      },
    },
  ];

  return (
    <>
      <Table data={tableData} columns={columns} pagination={false} />

      {selectedItem && (
        <ChannelConfigurator
          isOpen={isChannelModalOpen}
          onClose={() => setIsChannelModalOpen(false)}
          team={selectedItem}
          channelPermissions={channelPermissions}
          setChannelPermissions={setChannelPermissions}
        />
      )}
    </>
  );
};

export default ByRole;
